import { render, staticRenderFns } from "./CustomerQuotes.vue?vue&type=template&id=3e402afd&"
import script from "./CustomerQuotes.vue?vue&type=script&lang=js&"
export * from "./CustomerQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports